import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-directors-list',
  templateUrl: './directors-list.component.html',
  styleUrls: ['./directors-list.component.css']
})
export class DirectorsListComponent implements OnInit {

  @Input() userDirectors: any;
  math = Math;

  newSaleSumm: number = 0;

  saleSummPlan: number = 0;

  saleSummPlanPerc: number = 0;

  countAgents: number = 0;

  countFK6: number = 0;

  countFK9: number = 0;

  performanceIndicatorM: number = 0;

  performanceIndicatorY: number = 0;

  constructor() { }

  ngOnInit() {
    
  }

  ngOnChanges(){
    if(this.userDirectors.ag_tree != undefined){
      let countPlanPerc = 0;
      let countM = 0;
      let countY = 0;
      for(let summ of this.userDirectors.ag_tree){
        if(summ.plan != undefined){
          this.saleSummPlan = this.saleSummPlan + summ.plan;
        }
        if(summ.volume != undefined){
          this.newSaleSumm = this.newSaleSumm + summ.volume;
        }
        if(summ.volume != undefined){
          if(summ.plan != 0){
            this.saleSummPlanPerc = this.saleSummPlanPerc + (( summ.volume / summ.plan ) * 100); //среднее значаение rentability_month
          }
          else{
            this.saleSummPlanPerc = this.saleSummPlanPerc + 0;
          }
          countPlanPerc += 1;
        }
        if(summ.agents_count != undefined){
          this.countAgents = this.countAgents + summ.agents_count;
        }
        if(summ.agents_fc6_count != undefined){
          this.countFK6 = this.countFK6 + summ.agents_fc6_count;
        }

        if(summ.agents_fc9_count != undefined){
          this.countFK9 = this.countFK9 + summ.agents_fc9_count;
        }

        if(summ.rentability_month != undefined){
          this.performanceIndicatorM = this.performanceIndicatorM + summ.rentability_month;
          countM +=1;
        }

        if(summ.rentability_year != undefined){
          this.performanceIndicatorY = this.performanceIndicatorY + summ.rentability_year;
          countY +=1;
        }
        
      }
      if(countPlanPerc != 0){
        this.saleSummPlanPerc = this.saleSummPlanPerc / countPlanPerc;
      }
      else{
        this.saleSummPlanPerc = 0;
      }
      if(countM != 0){
        this.performanceIndicatorM = this.performanceIndicatorM / countM;
      }
      else{
        this.performanceIndicatorM = 0;
      }
      if(countY != 0){
        this.performanceIndicatorY = this.performanceIndicatorY / countY;
      }
      else{
        this.performanceIndicatorY = 0;
      }
    }
  }

}
